import { FormGroup } from '@angular/forms';
import { FundProductInterface, ProductFieldNames } from '@spa/api';
import { MaxLengthValidatorKey, MinLengthValidatorKey } from '@spa/validators';
import { MaximumNumberValidatorKey, MinimumNumberValidatorKey } from 'appEntries/panel/validators';
import { DurationInMonthsMaxLength, SymbolMaxLength, SymbolMinLength } from '../../../../../assets/descriptors';

export abstract class BaseProductForm<TForm> {
    public form: FormGroup;
    public controls: TForm;

    protected abstract customValidateForm(
        messageFunction: (controlsLabel?: string, controlLength?: number) => { [key: string]: string }): boolean;

    validateForm(messageFunction: (controlsLabel?: string, controlLength?: number) => { [key: string]: string }): boolean {
        if (this.form.invalid) {
            Object.keys(this.controls).forEach(key => {
                const control = this.controls[key];
                const formControl = this.form.get(control.name);

                if (formControl && formControl.invalid) {
                    control.errors = Object.keys(formControl.errors).map(errorKey => {
                        const name = control.placeholder.replace(' *', '');

                        if (key === ProductFieldNames.Code) {
                            switch (errorKey) {
                                case MaxLengthValidatorKey:
                                    return messageFunction(name, SymbolMaxLength)[errorKey];
                                case MinLengthValidatorKey:
                                    return messageFunction(name, SymbolMinLength)[errorKey];
                            }
                        }

                        if (errorKey === MinimumNumberValidatorKey) {
                            const minError = formControl.errors[errorKey];

                            return messageFunction(name, minError.min)[errorKey];
                        }

                        if (errorKey === MaximumNumberValidatorKey) {
                            const maxError = formControl.errors[errorKey];

                            return messageFunction(name, maxError.max)[errorKey];
                        }

                        if (key === ProductFieldNames.DurationInMonths && errorKey === MaxLengthValidatorKey) {
                            return messageFunction(name, DurationInMonthsMaxLength)[errorKey];
                        }

                        return messageFunction(name)[errorKey];
                    });
                }
            });

            return false;
        }

        return this.customValidateForm(messageFunction);
    }

    abstract initForm(product?: FundProductInterface): void;
}
